import {
  Box,
  Button,
  FileInput,
  Group,
  LoadingOverlay,
  Popover,
  Select,
  Text,
  TextInput,
} from "@mantine/core";
import { isNotEmpty, useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { IconCheck, IconX } from "@tabler/icons-react";
import { useCallback, useEffect, useState } from "react";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { isNullOrUndefined } from "../../../_base/extension/StringExtension";
import Repository from "../../../_base/helper/HttpHelper";
import { Khung } from "../../../model/CategoryProductFrame";
import {
  formatDateToString,
  urlToImageFile,
} from "../../../_base/helper/FunctionHelper";
import { uploadImageAddFolder } from "../../../api/ApiMore";

const CreateView = ({ id, onSearch }: { id: number; onSearch: any }) => {
  const entity = {
    id: 0,
    tenKhung: "",
    maSanPham: "",
    createdDate: "",
    createdBy: 0,
    lastUpdatedDate: "",
    lastUpdatedBy: 0,
    urlAnh: "",
    viTriKhung: "",
    classCss: "",
  };
  const handleChangeDataContent = (content: string | null) => {
    let modifiedString = content?.replace(
      /src="\/media/g,
      'src="https://hanoicomputercdn.com/media'
    );
    return modifiedString ? modifiedString : "";
  };
  const handleCreateCollection = async (values: any) => {
    open();
    const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);
    const formDataToSend = new FormData();

    Object.keys(values).forEach((key) => {
      if (values[key] !== null && values[key] !== undefined) {
        formDataToSend.append(key, values[key]);
      }
    });

    console.log("Form Data to Send:", Object.fromEntries(formDataToSend));

    try {
      await repository.post(`/TblKhung/update`, formDataToSend, {
        headers: { "Content-Type": "multipart/form-data" },
      });
    } catch (error) {
      console.error("Error creating collection:", error);
    } finally {
      close();
      modals.closeAll();
      onSearch();
    }
  };
  const [popoverOpened, setPopoverOpened] = useState(false);
  const [visible, { toggle, close, open }] = useDisclosure(false);
  const [isImageChange, setIsImageChange] = useState<boolean>(false);
  const [urlImage, setUrlImage] = useState<string>("");
  const [value, setValue] = useState();
  // const [dataCollection, setDataCollection] = useState<CategorySpecialModel[]>(
  //   []
  // );
  const [dataOptionCollection, setDataOptionCollection] = useState<any[]>([]);
  const form = useForm<Khung>({
    initialValues: {
      ...entity,
    },
    validate: {
      tenKhung: isNotEmpty("Chưa nhập tên bộ sưu tập"),
      viTriKhung: isNotEmpty("Chưa chọn vị trí khung"),
      urlAnh: (value: string | null | File | undefined) => {
        return !value || /^\s*$/.test(String(value))
          ? "Link chưa ảnh nhập"
          : // : !/^\/[a-z0-9]+(?:-[a-z0-9]+)*$/.test(value)
            // ? "Giá trị của Link phải theo định dạng /aa-bb-cc"
            undefined;
      },
      // metaKeyword: isNotEmpty("Chưa nhập từ khóa meta"),
      // metaDescription: isNotEmpty("Chưa nhập mô tả meta"),
      // status: isNotEmpty("Chưa chọn trạng thái !"),
      classCss: isNotEmpty("Chưa nhập class CSS"),
    },
  });
  // const loadDataCollection = async () => {
  //   setDataCollection([]);
  //   const data = await getListCollection("Active=true&Skip=0&Take=1000");
  //   setDataCollection(data?.data);
  // };

  const callApiGetData = useCallback(async () => {
    const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);
    open();
    const callApi = await repository.get(`/TblKhung/get-update?id=${id}`);
    if (!isNullOrUndefined(callApi) && !isNullOrUndefined(callApi?.data)) {
      const dataApi = callApi?.data;
      if (dataApi != null && !isNullOrUndefined(dataApi)) {
        // Convert parentId to string to match with Select options
        if (
          dataApi.urlAnh !== null &&
          dataApi.urlAnh !== undefined &&
          typeof dataApi.urlAnh == "string"
        ) {
          const imageFile = await urlToImageFile(dataApi?.urlAnh);

          // Tạo file mới với tên gốc từ API
          if (imageFile) {
            const newFile = new File([imageFile], dataApi.urlAnh, {
              type: imageFile.type,
              lastModified: imageFile.lastModified,
            });
            dataApi.urlAnh = newFile;
            console.log(newFile);
          }
        }
        const formData = {
          ...dataApi,
          Id: dataApi.Id ? dataApi.Id.toString() : null,
        };
        form.setValues(formData);
        setUrlImage(dataApi?.urlAnh);
      } else {
        NotificationExtension.Fails("Dữ liệu không tồn tại");
        modals.closeAll();
      }
      close();
    } else {
      NotificationExtension.Fails("Dữ liệu không tồn tại");
      modals.closeAll();
    }
  }, [id, open, close, form]);
  // Hàm để đếm số từ

  const handleUploadImage = async (files: File[] | File) => {
    if (!files) {
      NotificationExtension.Fails("File sai định dạng hoặc không tồn tại !");
      return;
    }

    const newDate = formatDateToString(new Date());
    const fileArray = Array.isArray(files) ? files : [files];

    if (fileArray.length === 0) {
      NotificationExtension.Fails("File sai định dạng hoặc không tồn tại !");
      return;
    } else {
      const res = await uploadImageAddFolder(
        `cdn/Media/Image/CollectionFrame/${newDate}`,
        fileArray
      );

      if (res && res.success) {
        const data = res.data;
        NotificationExtension.Success("Tải ảnh lên thành công !");
        setUrlImage(data[0]?.url);
      } else {
        NotificationExtension.Fails(res.message);
        setUrlImage("");
      }
    }
  };

  const handleChangeImage = (file: File | null) => {
    form.getInputProps("urlAnh").onChange(file);
    setIsImageChange(true);
  };

  const countWords = (text: string) => {
    const words = text.split(/\s+/).filter((word: any) => word !== "");
    return words.length;
  };

  // Hàm để đếm số kí tự
  const countCharacters = (text: string) => {
    return text.length;
  };

  console.log("form.getValue()", form.getValues());
  console.log("form.errors;", form.errors);
  // useEffect(() => {
  //   loadDataCollection();
  // }, []);

  useEffect(() => {
    if (id) {
      callApiGetData();
    }
  }, [id]);
  // useEffect(() => {
  //   setDataOptionCollection(
  //     dataCollection
  //       .filter((option) => option && option.id && option.name) // xóa những giá trị bị nul hoặc undefined
  //       .map((option) => ({
  //         value: option.id.toString(),
  //         label: option.name || "Không có tiêu đề",
  //       }))
  //   );
  // }, [dataCollection]);

  useEffect(() => {
    if (isImageChange) {
      const files = form.getValues()?.urlAnh;
      if (files && files instanceof File) {
        handleUploadImage(files);
      } else if (!files) {
        setUrlImage("");
      }
    }
  }, [form.getValues()?.urlAnh]);

  return (
    <>
      <Box
        className="flex-none"
        component="form"
        miw={1000}
        maw={1000}
        mx="auto"
        onSubmit={form.onSubmit((values) =>
          handleCreateCollection({ ...values, urlAnh: urlImage })
        )}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />
        <Group grow wrap="nowrap" mt="lg" gap={"lg"}>
          <TextInput
            label={"Tên bộ sưu tập"}
            placeholder={"Nhập tên bộ sưu tập"}
            withAsterisk
            mt="md"
            type="text"
            key={form.key("tenKhung")}
            {...form.getInputProps("tenKhung")}
          />
          <TextInput
            label={"Class CSS"}
            placeholder={"Nhập class CSS"}
            withAsterisk
            mt="md"
            type="text"
            key={form.key("classCss")}
            {...form.getInputProps("classCss")}
          />
        </Group>
        <Group grow wrap="nowrap" mt="lg" gap={"lg"}>
          <Select
            label={"Vị trí khung"}
            placeholder={"Chọn vị trí khung"}
            withAsterisk
            mt="md"
            data={[
              { value: "bottom", label: "Bên dưới" },
              { value: "left", label: "Bên trái" },
              { value: "right", label: "Bên phải" },
            ]}
            {...form.getInputProps("viTriKhung")}
          />
          {/* <Select
            label={"Bộ sưu tập cha"}
            placeholder={"Chọn bộ sưu tập cha"}
            clearable
            mt="md"
            data={dataOptionCollection}
            key={form.key("parentId")}
            nothingFoundMessage="Không có dữ liệu"
            {...form.getInputProps("parentId")}
          /> */}
          {/* <TextInput
            label={"URL ảnh "}
            placeholder={"Nhập URL ảnh"}
            withAsterisk
            mt="md"
            type="text"
            name="urlAnh"
            key={form.key("urlAnh")}
            {...form.getInputProps("urlAnh")}
          /> */}
          <FileInput
            label={"URL ảnh"}
            placeholder={"Nhập URL ảnh"}
            accept="image/png,image/jpeg"
            withAsterisk
            mt="md"
            value={form.getValues()?.urlAnh}
            {...form.getInputProps("urlAnh")}
            onChange={handleChangeImage}
          />
        </Group>
        {/* <Group grow wrap="nowrap" mt="lg" gap={"sm"} mb="md">
          <Checkbox
            label="Không đồng bộ giá"
            name="isSyncPrice"
            checked={form.getValues().isSyncPrice === "Y"}
            key={form.key("isSyncPrice")}
            onChange={(e) =>
              form.setFieldValue(
                "isSyncPrice",
                e.currentTarget.checked ? "Y" : "N"
              )
            }
          />
          <Checkbox
            label="Không đồng bộ tồn kho"
            name="isSyncStock"
            checked={form.getValues().isSyncStock === "Y"}
            key={form.key("isSyncStock")}
            onChange={(e) =>
              form.setFieldValue(
                "isSyncStock",
                e.currentTarget.checked ? "Y" : "N"
              )
            }
          />
        </Group> */}

        {/* <Text size="sm" mt="sm" fw={500}>
          Nội dung
        </Text>
        <QuillEditor
          toolbarId="t1"
          setValue={setValue}
          onChangeValue={(html: string) =>
            (form.values.description = handleChangeDataContent(html))
          }
          description={handleChangeDataContent(form.values.description)}
        />
        <Text size="sm" mt="sm" fw={700}>
          Dùng cho SEO
        </Text>
        <Group grow wrap="wrap" gap={"lg"}>
          <TextInput
            label={"Tiêu đề Meta"}
            placeholder={"Nhập tiêu đề meta"}
            withAsterisk
            name="metaTitle"
            key={form.key("metaTitle")}
            {...form.getInputProps("metaTitle")}
            onChange={(e) => {
              form.setFieldValue("metaTitle", e.target.value);
            }}
          />
          <p style={{ fontSize: 12.25, paddingTop: 20 }}>
            Số từ:{" "}
            <span style={{ fontWeight: 500 }}>
              {countWords(form.getValues().metaTitle?.toString() || "")}{" "}
            </span>
            , Số kí tự:{" "}
            <span style={{ fontWeight: 500 }}>
              {countCharacters(form.getValues().metaTitle?.toString() || "")}
            </span>
          </p>
        </Group> */}

        {/* <Group grow wrap="wrap" gap={"lg"}>
          <TextInput
            label={"Từ khóa Meta"}
            placeholder={"Nhập từ khóa meta"}
            withAsterisk
            name="metaKeyword"
            key={form.key("metaKeyword")}
            {...form.getInputProps("metaKeyword")}
            onChange={(e) => form.setFieldValue("metaKeyword", e.target.value)}
          />
          <p style={{ fontSize: 12.25, paddingTop: 20 }}>
            Số từ:{" "}
            <span style={{ fontWeight: 500 }}>
              {countWords(form.getValues().metaKeyword?.toString() || "")}{" "}
            </span>
            , Số kí tự:{" "}
            <span style={{ fontWeight: 500 }}>
              {countCharacters(form.getValues().metaKeyword?.toString() || "")}{" "}
            </span>
          </p>
        </Group>

        <Textarea
          label={"Mô tả Meta"}
          placeholder={"Nhập mô tả meta"}
          withAsterisk
          name="metaDescription"
          key={form.key("metaDescription")}
          {...form.getInputProps("metaDescription")}
          onChange={(e) =>
            form.setFieldValue("metaDescription", e.target.value)
          }
        />
        <p style={{ fontSize: 12.25 }}>
          Số từ:{" "}
          <span style={{ fontWeight: 500 }}>
            {countWords(form.getValues().metaDescription?.toString() || "")}{" "}
          </span>
          , Số kí tự:{" "}
          <span style={{ fontWeight: 500 }}>
            {countCharacters(
              form.getValues().metaDescription?.toString() || ""
            )}{" "}
          </span>
          <span style={{ fontWeight: 500 }}> (Khuyến nghị: 160 ký tự)</span>
        </p> */}
        <Group
          justify="center"
          mt="xs"
          p="5px 0"
          style={{
            position: "sticky",
            bottom: 0,
            backgroundColor: "white",
          }}
        >
          <Button
            type="submit"
            color="#3598dc"
            loading={visible}
            leftSection={!visible ? <IconCheck size={18} /> : undefined}
          >
            Lưu
          </Button>
          <Popover
            width={300}
            position="top"
            withArrow
            shadow="md"
            opened={popoverOpened}
            onChange={setPopoverOpened}
          >
            <Popover.Target>
              <Button
                color="red"
                style={{ marginLeft: 10 }}
                onClick={() => setPopoverOpened(true)}
                leftSection={<IconX size={18} />}
              >
                Đóng
              </Button>
            </Popover.Target>
            <Popover.Dropdown>
              <Text>Bạn có chắc chắn muốn đóng không?</Text>
              <Group grow mt="lg">
                <Button
                  color="red"
                  leftSection={<IconCheck size={18} />}
                  onClick={() => {
                    modals.closeAll();
                  }}
                >
                  Đóng
                </Button>
                <Button
                  variant="outline"
                  color="gray"
                  leftSection={<IconX size={18} />}
                  onClick={() => setPopoverOpened(false)}
                >
                  Hủy
                </Button>
              </Group>
            </Popover.Dropdown>
          </Popover>
        </Group>
      </Box>
    </>
  );
};

export default CreateView;
